import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Root\\Documents\\source\\law\\frontend\\src\\components\\shared\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Root\\Documents\\source\\law\\frontend\\src\\components\\shared\\Navbar.tsx");
